<template>
    <div class="dialog-container">
        <div class="dialog-overlay"></div> <!-- Sin evento @click -->
        <div class="dialog">
            <button class="dialog-close-btn" @click="closeDialog">X</button>
            <div class="dialog-header">
                <h2 class="dialog-title text-center">{{ title }}</h2>
            </div>            
            <div class="dialog-content">
                <slot></slot> <!-- Aquí se insertará el contenido adicional -->
            </div>
            <div class="dialog-footer">
                <button @click="closeDialog">Cerrar</button>
            </div>
        </div>
    </div>
</template>


<script>
import { v4 as uuid } from 'uuid';

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `dialog-input-${uuid()}`;
            },
        },
        title: String, // Nuevo prop para el título del diálogo
        type: {
            type: String,
            default: 'text',
        },
        error: String,
        label: String,
        modelValue: String,
    },
    emits: ['update:modelValue'],
    mounted() {
        document.addEventListener('keydown', this.preventEscapeKey);
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.preventEscapeKey);
    },
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        select() {
            this.$refs.input.select();
        },
        setSelectionRange(start, end) {
            this.$refs.input.setSelectionRange(start, end);
        },
        closeDialog() {
            this.$emit('close');
        },
        preventEscapeKey(e) {
            if (e.key === 'Escape') {
                e.preventDefault(); // Evitar que la tecla Escape cierre el diálogo
            }
        },
    },
};
</script>

<style scoped>
.dialog {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    max-width: 90%;
    /* Ajusta el ancho del diálogo según tus necesidades */
    position: relative;
    z-index: 1001;
    /* Asegura que el diálogo esté por encima de la capa translúcida */
}

.dialog-header {
    background-color: #f0f0f0;
    padding: 15px 20px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.dialog-title {
    /* margin: 0; */
    font-size: 1.5rem;
    color: #333;
}

/* Estilos anteriores */
.dialog-close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: #333;
}

.dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    /* Asegura que el diálogo esté por encima de otros elementos */
}

.dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* Transparencia del fondo */
    z-index: 999;
    /* Asegura que la capa translúcida esté detrás del diálogo */
}

.dialog-title {
    margin-top: 0;
}

.dialog {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    max-width: 80%;
    max-height: 80vh; /* Limita la altura máxima del diálogo */
    overflow: hidden; /* Evita que el contenido se desborde */
    position: relative;
    z-index: 1001;
}

.dialog-content {
    max-height: 50vh; /* Ajusta la altura máxima del contenido */
    overflow-y: auto; /* Activa el desplazamiento vertical si el contenido excede la altura */
    padding: 10px;
    border-top: 1px solid #333333;
    border-bottom: 1px solid #333333;
}

.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
.dialog-footer button {
  margin-left: 10px;
}

/* Estilos restantes que ya tenías para el input, label y error */
.dialog-label {
    /* Estilos para la etiqueta del diálogo */
}

.dialog-input {
    /* Estilos para el campo de entrada del diálogo */
}

.dialog-error {
    /* Estilos para el mensaje de error del diálogo */
}
</style>